import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  Info as InfoIcon,
} from '@mui/icons-material';

/**
 * Standalone "How Similarity Analysis Works" help accordion.
 * Sits at the bottom of the Application section.
 */
const HelpRow = () => (
  <Accordion
    disableGutters
    elevation={0}
    sx={{
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: '12px !important',
      mb: 1.5,
      '&::before': { display: 'none' },
      overflow: 'hidden',
    }}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      sx={{
        px: 2.5,
        minHeight: 56,
        '& .MuiAccordionSummary-content': { alignItems: 'center', gap: 2 },
      }}
    >
      <InfoIcon color="primary" />
      <Typography variant="subtitle1" fontWeight={600}>
        How Similarity Analysis Works
      </Typography>
    </AccordionSummary>

    <AccordionDetails sx={{ px: 2.5, pb: 2.5 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Process Overview
          </Typography>
          <Typography variant="body2" paragraph>
            When you preview or publish a feature file, the system analyzes each scenario
            and compares it against existing test cases to identify potential duplicates.
          </Typography>
          <Box component="ul" sx={{ pl: 2, '& li': { mb: 1 } }}>
            <li><Typography variant="body2"><strong>Step 1:</strong> Scenarios are converted to vector embeddings using AI models</Typography></li>
            <li><Typography variant="body2"><strong>Step 2:</strong> Cosine similarity is calculated against existing test case embeddings</Typography></li>
            <li><Typography variant="body2"><strong>Step 3:</strong> Matches above the threshold are flagged as potential duplicates</Typography></li>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
            Model Comparison
          </Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow sx={{ bgcolor: 'grey.50' }}>
                  <TableCell>Model</TableCell>
                  <TableCell>Speed</TableCell>
                  <TableCell>Accuracy</TableCell>
                  <TableCell>Best For</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>MiniLM-L6-v2</TableCell>
                  <TableCell><Chip label="Fast" size="small" color="success" /></TableCell>
                  <TableCell>Good</TableCell>
                  <TableCell>General use</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>BGE-small-en</TableCell>
                  <TableCell>Moderate</TableCell>
                  <TableCell><Chip label="Better" size="small" color="primary" /></TableCell>
                  <TableCell>Higher accuracy</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </AccordionDetails>
  </Accordion>
);

export default HelpRow;
